import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import Css from '@components/ExperiencesLandingPage/ExperiencesLandingPage.scss';
import { Link } from 'react-router-dom';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

const NextSteps = props => {
  let containerStyle = {
    maxWidth: props.pageWidth + 'px'
  };

  return (
    <Container className={'px-0'} fluid={true} style={containerStyle}>
      <Row
        style={{
          backgroundImage: `url(${Clouds})`
        }}
      >
        <Col
          lg="7"
          id={props.Location + '-landingpage-textbox'}
          className="text-center p-3 mx-auto mt-5 mb-3"
          style={{
            backgroundColor: '#e71c36'
          }}
        >
          <p className={Css.footerheader}>Next Steps</p>
          <p className={Css.footerregular + ' px-5 text-center'}>
            Contact JetSuite Experiences at{' '}
            <span className={'font-mid'}>866-359-4100</span> or{' '}
            <a
              href={'mailto:embark@JetSuite.com'}
              className={'color-white lakes-bold'}
            >
              embark@JetSuite.com
            </a>
            .
          </p>
        </Col>

        {props.hideBtn === undefined ? (
          <Col lg="6" className="mx-auto mt-3 mb-5 text-center">
            <div className={'text-dark lakes-medium font-lg'}>
              Not a JetSuite SuiteKey Member?
            </div>
            <Link
              className={'btn btn-fullred mt-2'}
              to="/suitekey-membership"
              onClick={() => {
                window.gtag('event', 'click', {
                  event_category: 'JS-Experiences-Engagement',
                  event_label: props.eventName
                });
              }}
            >
              JOIN
            </Link>
          </Col>
        ) : (
          <Col xs={12} className={'pt-4'} />
        )}
      </Row>
    </Container>
  );
};

export default NextSteps;



// WEBPACK FOOTER //
// ./src/components/Experiences/NextSteps/NextSteps.js